import { Button } from '@/components';
import { ButtonProps } from '@/components/atoms/Button/Button';
import { FC } from 'react';
interface Props extends ButtonProps {
  onDownloadClick?: (() => Promise<void> | void) | undefined;
}
const DownloadFromCloudButton: FC<Props> = ({ onDownloadClick, ...props }) => {
  const handleDownloadClick = () => {
    if (onDownloadClick) {
      onDownloadClick();
    }
  };
  return (
    <Button
      icon="downloadFromCloud"
      iconStyles={{ intent: 'accent', size: 'md' }}
      onClick={handleDownloadClick}
      className={props.className}
      {...props}
    >
      {props.children}
    </Button>
  );
};
export default DownloadFromCloudButton;
